import UniqFinalPackingListRoutes from "./uniq_final_packing_list";

export default [
    ...UniqFinalPackingListRoutes,
]
